<template>
  <!-- 自动回评-创建模板组件 -->
  <div>
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :with-header="false"
      :before-close="handleClose"
    >
      <div class="createTpl">
        <!-- 抽屉头部 -->
        <header class="head">
          <span>回评规则</span>
          <i class="el-icon-close close" @click="handleClose()"></i>
        </header>

        <!-- 表单内容 -->
        <section class="createTplMain">
          <el-form
            ref="formSearch"
            :rules="rules"
            :model="form"
            label-width="100px"
          >
            <el-form-item label="模板名称:">
              <el-input
                placeholder="请输入模板名称"
                v-model="form.templetName"
                style="width: 280px;"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="任务时间:">
              <div class="taskTime">
                <el-radio-group v-model="form.persistentOpenFlag">
                  <el-radio :label="1">持续开启</el-radio>
                  <el-radio :label="0">指定时间</el-radio>
                </el-radio-group>
                <div class="my_select_time" style="marginLeft: 6px;">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.taskAllowRunStartTime"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    :disabled="taskTimeDisabled"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px;font-size:12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div
                    class="time_to_text"
                    :class="{ to_text_disabled: taskTimeDisabled }"
                  >
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.taskAllowRunEndTime"
                    type="datetime"
                    :disabled="taskTimeDisabled"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px;font-size:12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTaskTime()"
                  ></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="评价分数:" prop="commentScore">
              <el-checkbox-group v-model="form.commentScore">
                <el-checkbox label="1星">一星</el-checkbox>
                <el-checkbox label="2星">二星</el-checkbox>
                <el-checkbox label="3星">三星</el-checkbox>
                <el-checkbox label="4星">四星</el-checkbox>
                <el-checkbox label="5星">五星</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="关键词:">
              <el-input
                placeholder='多个关键词用英文","隔开'
                v-model="form.keyWord"
                style="width: 280px;"
              >
              </el-input>
              <span style="color: #666;">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
            display: inline-block;
            width: 14px;
            height: 14px;
                        position: absolute;
            color: #ffffff;
            margin: 8px 4px 0 20px;
          "
                /><span style="margin-left:40px">不填则不限</span>
              </span>
            </el-form-item>

            <el-form-item label="指定商品:" style="color:#666">
              <button
                class="selectBtn"
                @click.prevent="openSelectGoods"
              >
                已选择 {{ selectGoodsNum() }} 个商品
              </button>
              <span style="color: #666;">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
            display: inline-block;
            width: 14px;
            height: 14px;
                        position: absolute;
            color: #ffffff;
            margin: 8px 4px 0 20px;
          "
                /><span style="margin-left:40px">不选择默认适用所有商品</span>
              </span>
            </el-form-item>

            <el-form-item label="回评内容:">
              <div class="contentBox">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="form.content"
                  rows="6"
                  resize="none"
                >
                </el-input>
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
            display: inline-block;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 6px 4px 0 6px;
          "
                />
                <span style="color: #666;">
                  此回复不是给客户发短信，而是直接回到商品详情页
                </span>
              </div>
            </el-form-item>
          </el-form>
        </section>
                <!-- 底部按钮 -->
                <footer class="footBtn">
                    <button class="keepOpenBtn" v-if="disBtn1" ><i class="el-icon-loading"></i>保存并开启</button>
                    <button class="keepOpenBtn" v-else @click="handleKeppData(true)">保存并开启</button>
                    <button class="keepBtn" v-if="disBtn2"><i class="el-icon-loading"></i>保存设置</button>
                    <button class="keepBtn" v-else @click="handleKeppData(false)">保存设置</button>
                </footer>
            </div>
        </el-drawer>
    <selectGoods
      :isShow="selectGoodsState"
      v-if="selectGoodsState"
      :skuSearch="true"
      @close="selectGoodsClose"
      :moduleType="true"
      :selectGoods="selectGoodsData"
      :selectGoodsSkuList="selectGoodsSkuList"
    ></selectGoods>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor";
import { addAutoAssess } from "@/api/serviceCenter/autoReplyComment";

export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    selectGoods,
  },
  watch: {
    drawer(newVal) {
      if (newVal && this.editData.id) {
        console.log(this.editData);
        let data = this.editData;
        data.goodsList = data.goodsList ? data.goodsList : [];
        data.keyWord = data.keyWord ? data.keyWord : "";
        this.selectGoodsData = data.goodsList;
        this.form = data;
      } else {
        this.form.templetName = "自动回评" + this.getNowDate();
        this.selectGoodsData = [];
      }
    },
  },
  computed: {
    // 任务时间日期选择器是否禁用
    taskTimeDisabled() {
      return this.form.persistentOpenFlag == 1 ? true : false;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },

  data() {
    return {
      /**
       * 表单数据
       * templetName: 模板名称
       * persistentOpenFlag: 任务时间选中
       * taskTimeStart: 任务时间-指定时间开始日期
       * taskTimeEnd: 任务时间-指定时间结束日期
       * commentScore: 评价分数
       * keyWord: 关键词
       * goodsList: 选择的商品
       * content: 回评内容
       * isOpen: 是否开启 0 关闭 1 开启
       * itemFilterType: 商品过滤规则，1不过滤，2，过滤选择的商品，3，不过滤选择的商品 ,
       * */
      // venderType: "",
      form: {
        templetName: null,
        persistentOpenFlag: 1,
        taskAllowRunStartTime: null,
        taskAllowRunEndTime: null,
        commentScore: [],
        keyWord: null,
        goodsList: [],
        content: null,
        isOpen: 0,
        itemFilterType: 1,
      },
      rules: {
        commentScore: [
          {
            required: true,
            message: "请至少选择一个评价分数",
            trigger: "change",
          },
        ],
      },
      disBtn1: false,
      loadBtn1: false,
      disBtn2: false,
      selectGoodsState: false,
      // 选中的商品数据
      selectGoodsData: [],
      // 用于回显
      selectGoodsSkuList:[]
    };
  },
  

    methods: {
      selectGoodsNum(){
        let selectGoodsSkuList = []
        this.selectGoodsData.forEach(it=>{
            if(it.skuList){
              it.skuList.forEach(item=>{
                selectGoodsSkuList.push(item)
              })
            }else{
              selectGoodsSkuList.push(it)
            }
        })
        return selectGoodsSkuList.length
      },
      openSelectGoods(){
          this.selectGoodsSkuList = []
          this.selectGoodsData.forEach(it=>{
            if(it.skuList){
              it.skuList.forEach(item=>{
                this.selectGoodsSkuList.push(item)
              })
            }else{
              this.selectGoodsSkuList.push(it)
            }
          })
          this.selectGoodsState = true
          console.log(this.selectGoodsData)
      },
      handleClose(state = false) {
            // state 为 true 时刷新列表
            this.$emit('close', state);
            // 重置数据
            this.form = {
                templetName: null,
                persistentOpenFlag: 0, 
                taskAllowRunStartTime: null,
                taskAllowRunEndTime: null,
                commentScore: [],
                keyWord: null,
                goodsList: [],
                content: null,
                isOpen: 0,
                itemFilterType: 1
            }
            this.selectGoodsData = [];
        },
        // 选择商品数据接收
        selectGoodsClose(data) {
          console.log("??????")
          console.log(data)
          if(!data) {
              this.selectGoodsState = false;
              return
          };
          this.selectGoodsData = data;
          console.log(this.selectGoodsData);
            // let goodsList = [];
            
            // // 将选中商品下的skuList作为数据
            // data.forEach(item=>{
            //     item.skuList.map(ele=>{
            //         goodsList.push({
            //             goodID: ele.wareId,
            //             goodMon: ele.jdPrice,
            //             goodTxt: ele.wareTitle,
            //             imgSrc: ele.logo,
            //             skuId: ele.skuId
            //         })
            //     })
            // })
            
            // let goodsList = data.map(item => {
            //     return {
            //         goodID: item.wareId,
            //         goodMon: item.jdPrice,
            //         goodTxt: item.wareTitle,
            //         imgSrc: item.logo,
            //         skuId: item.skuId
            //     }
            // })
            // this.form.goodsList = goodsList;
            this.selectGoodsState = false;
        },
        // 保存并开启 || 保存设置
        handleKeppData(state) {
            let goodsList = [];
            console.log(this.selectGoodsData)
            this.selectGoodsData.forEach(item=>{
              // console.log('this.venderType:', this.venderType)
              // if (this.venderType) {
                // 自营
                if (item && item.skuList) {
                  item.skuList.map(ele=>{
                      goodsList.push({
                          goodID: ele.wareId,
                          goodMon: ele.jdPrice,
                          goodTxt: ele.wareTitle,
                          imgSrc: ele.logo,
                          skuId: ele.skuId
                      })
                  })
                }else{
                  goodsList.push({
                  goodID: item.wareId,
                  goodMon: item.jdPrice,
                  goodTxt: item.wareTitle,
                  imgSrc: item.logo,
                  skuId: item.skuId
                })
                }
              // } else {
              // }
            })
            console.log(goodsList)
            this.form.goodsList = goodsList;
            console.log(this.$parent.$route.name);
            if( this.form.commentScore.length ==0){
                this.$message.warning("请选择至少一个评价分数")
                return
            }
            // return
            if(this.$parent.$route.name =="autoassess"){
                state ? this.form.isOpen = 1 : this.form.isOpen = 2;
                state ? this.disBtn1=true : this.disBtn2 = true;
                
            }else{
                state ? this.form.isOpen = 1 : this.form.isOpen = 0;
            }
            // this.form.commentScore && (this.form.commentScore = this.form.commentScore.join(','))
            this.form.itemFilterType = this.form.goodsList.length > 0 ? 3 : 1;
            console.log( this.form);
            let params = {
                ...this.form,
            }
            params.commentScore = this.form.commentScore && this.form.commentScore.join(',')
            // return
            

            addAutoAssess(params).then(res => {
                if (res && res.code == 1) {
                    this.handleClose(true);
                    this.$message.success('保存成功')
                }else{
                    this.$message.success(res.message)
                }
                this.disBtn1=false;
                this.disBtn2=false;
            })
        },
        /**
         * 清除任务时间
         */
        clearTaskTime() {
            this.taskTime.start = null;
            this.taskTime.end = null
        },
        // 获取当前时间
        getNowDate() {
            var myDate = new Date(); //实例一个时间对象；
            const y = myDate.getFullYear();   //获取系统的年；
            const M = myDate.getMonth()+1;   //获取系统月份，由于月份是从0开始计算，所以要加1
            const d = myDate.getDate(); // 获取系统日，
            const h = myDate.getHours(); //获取系统时，
            const m = myDate.getMinutes(); //分
            const s = myDate.getSeconds(); //秒
            return y+String(M)+d + ' ' + h+':'+m+':'+s
        }
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer {
  width: 894px !important;
}
.createTpl {
  display: flex;
  flex-direction: column;
  height: 100%;
  .head {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 28px;
    height: 62px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    .close {
      cursor: pointer;
      color: #ccc;
    }
  }
  .createTplMain {
    flex: 1;
    box-sizing: border-box;
    padding: 40px 0 0 38px;
    .selectBtn {
      width: 126px;
      height: 32px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      cursor: pointer;
      outline: none;
      color: #fe4d45;
      background-color: #fff4f4;
      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }
    }
    .contentBox {
      box-sizing: border-box;
      width: 720px;
      height: 178px;
      padding: 8px 8px 15px;
      background-color: #f9fafb;
      border-radius: 2px;
    }
  }
  .footBtn {
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 48px;
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #f0f0f0;
    .keepOpenBtn,
    .keepBtn {
      width: 98px;
      height: 32px;
      font-size: 14px;
      font-weight: 400;
      outline: none;
      background-color: white;
      border: none;
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .keepOpenBtn {
      margin-right: 12px;
      color: #fff;
      background-color: #fe4d45;
      &:hover {
        opacity: 0.9;
      }
    }
    .keepBtn {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
  }
}
</style>
